import React from 'react';
import translations from '../../assets/translations/translation';

const ModalDeleteChatHistory = ({
  dettagliProgetto,
  CancellaCronologiaChat,
  setIsOpen,
  locale,
}) => {
  return (
    <div
      className="modal-clear-history-overlay modal-clear-history-show"
      style={{ zIndex: '99999999999999' }}
    >
      <div className="modal-clear-history-modal">
        <div className="modal-clear-history-header">
          <button
            className="modal-clear-history-close-button"
            onClick={(e) => setIsOpen(!e)}
            style={{ color: 'black' }}
          >
            ×
          </button>
        </div>
        <div className="modal-clear-history-body">
          {translations[`modalClearHistoryText-${locale}`]}
        </div>
        <div className="modal-clear-history-footer">
          <button
            className="modal-clear-history-button modal-clear-history-cancel"
            onClick={(e) => setIsOpen(!e)}
          >
            {translations[`modalClearHistoryCancel-${locale}`]}
          </button>
          <button
            className="modal-clear-history-button modal-clear-history-confirm"
            onClick={CancellaCronologiaChat}
          >
            {translations[`modalClearHistoryConfirm-${locale}`]}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalDeleteChatHistory;
